<template>
  <div class="content">
    <nav01 title="解锁权限"></nav01>
    <!-- <p class="tips">
      <img src="../../../assets/game/gmTool/gm_pay_slice.png" alt="" />
      <van-notice-bar
        scrollable
        text="GM游戏为无隐藏封顶消费游戏，会出现不可预知的情况。元宝道具都可无限发放，刷取过多可能会造成战力不稳定等情况，该问题无法解决。"
      />
    </p> -->

    <ul class="account-info">
      <!-- <li>
        <div>
          <p>所在游戏</p>
          <span>{{ state.userInfo.gamename }}</span>
        </div>
        <p>区服：{{ state.userInfo.zonename }}</p>
      </li>
      <i></i>
      <li>
        <div>
          <p>我的账号</p>
          <span>{{ state.username }}</span>
        </div>
        <p>小号：{{ state.userInfo.nickname }}</p>
      </li>
      <i></i> -->
      <li>
        <div>
          <p>我的角色</p>
          <span>{{ state.userInfo.rolename }}</span>
        </div>
        <p>角色ID：{{ state.userInfo.roleid }}</p>
      </li>
      <i></i>
      <li>
        <div>
          <p>权限信息</p>
          <span>{{ state.userInfo.price }}</span>
        </div>
        <p>已有权限：{{ state.yzf_price }}</p>
      </li>
      <i></i>
      <li>
        <div>
          <p>支付金额</p>
          <span style="color: #ff6666">{{ calcPrice }}</span>
        </div>
      </li>
    </ul>

    <div class="pay-way">
      <h2>选择支付方式</h2>
      <ul>
        <li @click="pay('zfb')">
          <div>
            <img src="../../../assets/personal/yz_yecz_zfb_ico.png" />
            支付宝
          </div>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Iconsax/Bulk/ethereumclassic">
              <path
                id="Vector"
                opacity="0.4"
                d="M3.54028 11.6523L5.61693 7.02441C5.70509 6.8211 5.70509 6.58873 5.61693 6.3951L3.54028 1.76721C3.35416 1.36057 3.85374 0.982986 4.20637 1.26376L10.1914 6.10464C10.6029 6.43382 10.6029 6.976 10.1914 7.30518L4.20637 12.1461C3.85374 12.4365 3.35416 12.0686 3.54028 11.6523Z"
                fill="white"
              />
            </g>
          </svg>
        </li>
        <li @click="pay('wx')">
          <div>
            <img src="../../../assets/personal/yz_yecz_wx_ico.png" />
            微信
          </div>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Iconsax/Bulk/ethereumclassic">
              <path
                id="Vector"
                opacity="0.4"
                d="M3.54028 11.6523L5.61693 7.02441C5.70509 6.8211 5.70509 6.58873 5.61693 6.3951L3.54028 1.76721C3.35416 1.36057 3.85374 0.982986 4.20637 1.26376L10.1914 6.10464C10.6029 6.43382 10.6029 6.976 10.1914 7.30518L4.20637 12.1461C3.85374 12.4365 3.35416 12.0686 3.54028 11.6523Z"
                fill="white"
              />
            </g>
          </svg>
        </li>
      </ul>
    </div>

    <!-- <button @click="pay">立即支付</button> -->
  </div>
</template>
<script setup>
import store from "@/store";
import { Local } from "@/utils/storage";
import { computed, onActivated, reactive, ref } from "vue";

const state = reactive({
  checked: "zfb",
  userInfo: {},
  username: getQueryString("username") || "",
  yzf_price: "",
  cporderid: "",
});

onActivated(() => {
  console.log("onActivated");
  inituserInfo();
  getActualPrice();
});

const inituserInfo = () => {
  let cache = Local.get("gmPayInfo");
  state.userInfo = cache;
};

import { gmAlipay, getGmPrice, gmWxpay } from "@/api/yzgame";
const calcPrice = ref(0);
const getActualPrice = async () => {
  try {
    let res = await getGmPrice({
      game_id: getQueryString("gid"),
      tier_id: state.userInfo.id,
      username: state.username,
      role_id: state.userInfo.roleid,
      serverid: state.userInfo.zoneid,
      xiaohao: state.userInfo.xh,
    });
    // console.log("实际支付价格接口-------", res.data);
    if (res.data.code == 1) {
      calcPrice.value = res.data.data.amount;
      state.yzf_price = res.data.data.yzf_price;
      state.cporderid = res.data.data.cporderid;
    } else {
      Toast(res.data.msg);
    }
  } catch (error) {
    throw error;
  }
};
/**
 * 用户名 username
 * 角色名 role_name
 * 角色id role_id
 * 游戏id game_id
 * 权限id tier_id
 * 订单价格 order_price
 * 实付价格 actual_price
 * 订单号 orderid
 * 区服 server
 * 小号 xiaohao
 */
import { randomString } from "@/utils/device";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";
import { detect } from "@/utils/device";
const pay = async (payType) => {
  try {
    let data = {
      username: state.username,
      role_name: state.userInfo.rolename,
      role_id: state.userInfo.roleid,
      game_id: getQueryString("gid"),
      tier_id: state.userInfo.id,
      order_price: state.userInfo.price,
      actual_price: calcPrice.value,
      orderid: "zksq_gm_" + `${state.checked}_` + randomString(6) + Date.now(),
      server: state.userInfo.zonename,
      xiaohao: state.userInfo.xh,
      cporderid: state.cporderid,
      tier_name: state.userInfo.tier_name,
    };
    // console.log("GM订单信息-------", data);
    if (payType == "zfb") {
      if (detect() == "ios") {
        window.webkit.messageHandlers.JsBridge.postMessage([
          "onPayGmWithZfb",
          JSON.stringify(data),
        ]);
      } else {
        window.JsBridge.onPayGmWithZfb(JSON.stringify(data));
      }
      // gmWxpay(data).then((response) => {
    } else {
      console.log("微信支付接口-------", JSON.stringify(data));
      if (detect() == "ios") {
        window.webkit.messageHandlers.JsBridge.postMessage([
          "onPayGmWithWx",
          JSON.stringify(data),
        ]);
      } else {
        window.JsBridge.onPayGmWithWx(JSON.stringify(data));
      }
    }
  } catch (error) {
    throw error;
  }
};
</script>
<style scoped>
:deep(.van-nav-bar) {
  background-color: #161b1f;
}
.myNav {
  padding-left: 0;
  background-color: #161b1f;
  z-index: 99;
  justify-content: center;
}
:deep(.myNav img) {
  position: absolute;
  left: 0;
}
.content {
  background-color: #161b1f;
  height: 100vh;
  overflow: auto;
  padding: 0 32px;
  padding-bottom: calc(140px + constant(safe-area-inset-bottom));
  padding-bottom: calc(140px + env(safe-area-inset-bottom));
  position: relative;
}
.content h3 {
  text-align: center;
  margin-bottom: 36px;
  padding-top: 20px;
  background-color: #161b1f;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2001;
  font-size: 32px;
}
.tips {
  margin-top: 120px;
  display: flex;
  align-items: center;
  width: 686px;
  height: 72px;
  background-color: #283138;
  border-radius: 24px;
  padding: 0 20px 0 32px;
  overflow: hidden;
}
.tips img {
  width: 44px;
  height: 44px;
}
.tips .van-notice-bar {
  width: 100%;
  height: 100%;
  background-color: #283138;
  color: #ff6666;
  padding: 0;
  padding-left: 15px;
  font-weight: 500;
  font-size: 20px;
}

.account-info {
  margin-top: 14px;
  width: 686px;
  background: #283138;
  border-radius: 24px;
  padding: 0 32px;
  color: #fff;
}
.account-info li {
  padding: 20px 0;
}
.account-info li div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
}
.account-info li > p {
  margin-top: 16px;
  color: #999999;
  font-size: 24px;
}
.account-info li span {
  color: #999999;
  font-size: 20px;
}
.account-info i {
  width: 622px;
  height: 2px;
  background: #666666;
  border-radius: 0px 0px 0px 0px;
  display: block;
}

.pay-way {
  width: 686px;
  /* background-color: #283138; */
  border-radius: 24px;
  margin-top: 20px;
  padding: 32px;
}
.pay-way h2 {
  margin-bottom: 24px;
  font-size: 28px;
  color: #fff;
}
.pay-way ul {
  display: flex;
  justify-content: space-between;
}
.pay-way li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #283138;
  width: 294px;
  height: 100px;
  border-radius: 10px;
  padding: 0 32px;
  margin-bottom: 16px;
  color: #fff;
}
.pay-way li div {
  display: flex;
  align-items: center;
}
.pay-way img {
  width: 60px;
  height: 60px;
  margin-right: 20px;
}
button {
  margin-top: 24px;
  width: 686px;
  height: 96px;
  background: linear-gradient(90deg, #00d9c5 0%, #20c3de 100%);
  border-radius: 198px;
  border: none;
  font-weight: 600;
  font-size: 36px;
  color: #ffffff;
  position: fixed;
  bottom: calc(20px + constant(safe-area-inset-bottom));
  bottom: calc(20px + env(safe-area-inset-bottom));
}
</style>
